<template>
  <router-link onclick="gtag('event', 'click_btn', {'btn_name': 'Find the magic'})" to="/magic" class="float-btn hover-float-bg"
               :class="[{ smallMenu: getSmallMenu }, { bigMenu: !getSmallMenu }, { white: getIsWhiteBg }]">

    <div class="big-wrapper">
      <p>Find the magic</p>
      <svg class="static" viewBox="0 0 218 47" fill="none"
           xmlns="http://www.w3.org/2000/svg">
        <path
            d="M1.12695 6.75H4.50195V10.125C4.50195 10.4234 4.62048 10.7095 4.83146 10.9205C5.04244 11.1315 5.32858 11.25 5.62695 11.25C5.92532 11.25 6.21147 11.1315 6.42245 10.9205C6.63343 10.7095 6.75195 10.4234 6.75195 10.125V6.75H10.127C10.4253 6.75 10.7115 6.63147 10.9224 6.42049C11.1334 6.20952 11.252 5.92337 11.252 5.625C11.252 5.32663 11.1334 5.04048 10.9224 4.8295C10.7115 4.61853 10.4253 4.5 10.127 4.5H6.75195V1.125C6.75195 0.826631 6.63343 0.540483 6.42245 0.329505C6.21147 0.118526 5.92532 0 5.62695 0C5.32858 0 5.04244 0.118526 4.83146 0.329505C4.62048 0.540483 4.50195 0.826631 4.50195 1.125V4.5H1.12695C0.828585 4.5 0.542436 4.61853 0.331458 4.8295C0.120479 5.04048 0.00195313 5.32663 0.00195312 5.625C0.00195313 5.92337 0.120479 6.20952 0.331458 6.42049C0.542436 6.63147 0.828585 6.75 1.12695 6.75Z"
            fill="white"/>
        <path
            d="M217.752 33.1252C217.752 33.4236 217.633 33.7097 217.422 33.9207C217.211 34.1317 216.925 34.2502 216.627 34.2502H213.252V37.6252C213.252 37.9236 213.133 38.2097 212.922 38.4207C212.711 38.6317 212.425 38.7502 212.127 38.7502C211.829 38.7502 211.542 38.6317 211.331 38.4207C211.12 38.2097 211.002 37.9236 211.002 37.6252V34.2502H207.627C207.329 34.2502 207.042 34.1317 206.831 33.9207C206.62 33.7097 206.502 33.4236 206.502 33.1252C206.502 32.8268 206.62 32.5407 206.831 32.3297C207.042 32.1187 207.329 32.0002 207.627 32.0002H211.002V28.6252C211.002 28.3268 211.12 28.0407 211.331 27.8297C211.542 27.6187 211.829 27.5002 212.127 27.5002C212.425 27.5002 212.711 27.6187 212.922 27.8297C213.133 28.0407 213.252 28.3268 213.252 28.6252V32.0002H216.627C216.925 32.0002 217.211 32.1187 217.422 32.3297C217.633 32.5407 217.752 32.8268 217.752 33.1252ZM206.127 41.0002H204.252V39.1252C204.252 38.8268 204.133 38.5407 203.922 38.3297C203.711 38.1187 203.425 38.0002 203.127 38.0002C202.829 38.0002 202.542 38.1187 202.331 38.3297C202.12 38.5407 202.002 38.8268 202.002 39.1252V41.0002H200.127C199.829 41.0002 199.542 41.1187 199.331 41.3297C199.12 41.5407 199.002 41.8268 199.002 42.1252C199.002 42.4236 199.12 42.7097 199.331 42.9207C199.542 43.1317 199.829 43.2502 200.127 43.2502H202.002V45.1252C202.002 45.4236 202.12 45.7097 202.331 45.9207C202.542 46.1317 202.829 46.2502 203.127 46.2502C203.425 46.2502 203.711 46.1317 203.922 45.9207C204.133 45.7097 204.252 45.4236 204.252 45.1252V43.2502H206.127C206.425 43.2502 206.711 43.1317 206.922 42.9207C207.133 42.7097 207.252 42.4236 207.252 42.1252C207.252 41.8268 207.133 41.5407 206.922 41.3297C206.711 41.1187 206.425 41.0002 206.127 41.0002Z"
            fill="white"/>
      </svg>

      <div class="star-wrapper">
        <svg :class="`svg__${value}`" v-for="(value) in 8" :key="value" viewBox="0 0 12 12" fill="none"
             xmlns="http://www.w3.org/2000/svg">
          <path
              d="M1.12695 6.75H4.50195V10.125C4.50195 10.4234 4.62048 10.7095 4.83146 10.9205C5.04244 11.1315 5.32858 11.25 5.62695 11.25C5.92532 11.25 6.21147 11.1315 6.42245 10.9205C6.63343 10.7095 6.75195 10.4234 6.75195 10.125V6.75H10.127C10.4253 6.75 10.7115 6.63147 10.9224 6.42049C11.1334 6.20952 11.252 5.92337 11.252 5.625C11.252 5.32663 11.1334 5.04048 10.9224 4.8295C10.7115 4.61853 10.4253 4.5 10.127 4.5H6.75195V1.125C6.75195 0.826631 6.63343 0.540483 6.42245 0.329505C6.21147 0.118526 5.92532 0 5.62695 0C5.32858 0 5.04244 0.118526 4.83146 0.329505C4.62048 0.540483 4.50195 0.826631 4.50195 1.125V4.5H1.12695C0.828585 4.5 0.542436 4.61853 0.331458 4.8295C0.120479 5.04048 0.00195313 5.32663 0.00195312 5.625C0.00195313 5.92337 0.120479 6.20952 0.331458 6.42049C0.542436 6.63147 0.828585 6.75 1.12695 6.75Z"
              fill="white"/>
        </svg>
      </div>
    </div>

    <div v-show="getSmallMenu"
         class="small-wrapper">
      <svg width="41" height="36" viewBox="0 0 41 36" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M40.1251 22.5C40.1251 22.7984 40.0066 23.0845 39.7956 23.2955C39.5846 23.5065 39.2985 23.625 39.0001 23.625H35.6251V27C35.6251 27.2984 35.5066 27.5845 35.2956 27.7955C35.0846 28.0065 34.7985 28.125 34.5001 28.125C34.2017 28.125 33.9156 28.0065 33.7046 27.7955C33.4936 27.5845 33.3751 27.2984 33.3751 27V23.625H30.0001C29.7017 23.625 29.4156 23.5065 29.2046 23.2955C28.9936 23.0845 28.8751 22.7984 28.8751 22.5C28.8751 22.2016 28.9936 21.9155 29.2046 21.7045C29.4156 21.4935 29.7017 21.375 30.0001 21.375H33.3751V18C33.3751 17.7016 33.4936 17.4155 33.7046 17.2045C33.9156 16.9935 34.2017 16.875 34.5001 16.875C34.7985 16.875 35.0846 16.9935 35.2956 17.2045C35.5066 17.4155 35.6251 17.7016 35.6251 18V21.375H39.0001C39.2985 21.375 39.5846 21.4935 39.7956 21.7045C40.0066 21.9155 40.1251 22.2016 40.1251 22.5ZM4.50011 7.125H7.87511V10.5C7.87511 10.7984 7.99364 11.0845 8.20462 11.2955C8.4156 11.5065 8.70174 11.625 9.00011 11.625C9.29848 11.625 9.58463 11.5065 9.79561 11.2955C10.0066 11.0845 10.1251 10.7984 10.1251 10.5V7.125H13.5001C13.7985 7.125 14.0846 7.00647 14.2956 6.79549C14.5066 6.58452 14.6251 6.29837 14.6251 6C14.6251 5.70163 14.5066 5.41548 14.2956 5.2045C14.0846 4.99353 13.7985 4.875 13.5001 4.875H10.1251V1.5C10.1251 1.20163 10.0066 0.915482 9.79561 0.704504C9.58463 0.493525 9.29848 0.374999 9.00011 0.374999C8.70174 0.374999 8.4156 0.493525 8.20462 0.704504C7.99364 0.915482 7.87511 1.20163 7.87511 1.5V4.875H4.50011C4.20174 4.875 3.91559 4.99353 3.70462 5.2045C3.49364 5.41548 3.37511 5.70163 3.37511 6C3.37511 6.29837 3.49364 6.58452 3.70462 6.79549C3.91559 7.00647 4.20174 7.125 4.50011 7.125ZM28.5001 30.375H26.6251V28.5C26.6251 28.2016 26.5066 27.9155 26.2956 27.7045C26.0846 27.4935 25.7985 27.375 25.5001 27.375C25.2017 27.375 24.9156 27.4935 24.7046 27.7045C24.4936 27.9155 24.3751 28.2016 24.3751 28.5V30.375H22.5001C22.2017 30.375 21.9156 30.4935 21.7046 30.7045C21.4936 30.9155 21.3751 31.2016 21.3751 31.5C21.3751 31.7984 21.4936 32.0845 21.7046 32.2955C21.9156 32.5065 22.2017 32.625 22.5001 32.625H24.3751V34.5C24.3751 34.7984 24.4936 35.0845 24.7046 35.2955C24.9156 35.5065 25.2017 35.625 25.5001 35.625C25.7985 35.625 26.0846 35.5065 26.2956 35.2955C26.5066 35.0845 26.6251 34.7984 26.6251 34.5V32.625H28.5001C28.7985 32.625 29.0846 32.5065 29.2956 32.2955C29.5066 32.0845 29.6251 31.7984 29.6251 31.5C29.6251 31.2016 29.5066 30.9155 29.2956 30.7045C29.0846 30.4935 28.7985 30.375 28.5001 30.375ZM34.8564 8.73562L8.73386 34.8562C8.4901 35.1 8.20071 35.2934 7.88222 35.4253C7.56372 35.5573 7.22235 35.6252 6.87761 35.6252C6.53287 35.6252 6.1915 35.5573 5.87301 35.4253C5.55451 35.2934 5.26512 35.1 5.02136 34.8562L1.14199 30.9769C0.898204 30.7331 0.704824 30.4437 0.572889 30.1252C0.440953 29.8067 0.373047 29.4654 0.373047 29.1206C0.373047 28.7759 0.440953 28.4345 0.572889 28.116C0.704824 27.7975 0.898204 27.5081 1.14199 27.2644L27.2645 1.14375C27.5082 0.899966 27.7976 0.706586 28.1161 0.574651C28.4346 0.442716 28.776 0.374809 29.1207 0.374809C29.4655 0.374809 29.8068 0.442716 30.1253 0.574651C30.4438 0.706586 30.7332 0.899966 30.977 1.14375L34.8564 5.02312C35.1001 5.26688 35.2935 5.55627 35.4255 5.87477C35.5574 6.19327 35.6253 6.53463 35.6253 6.87937C35.6253 7.22412 35.5574 7.56548 35.4255 7.88398C35.2935 8.20248 35.1001 8.49187 34.8564 8.73562ZM25.4082 15L21.0001 10.5919L2.73386 28.8562C2.699 28.8911 2.67134 28.9324 2.65246 28.978C2.63359 29.0235 2.62388 29.0723 2.62388 29.1216C2.62388 29.1708 2.63359 29.2196 2.65246 29.2652C2.67134 29.3107 2.699 29.352 2.73386 29.3869L6.61324 33.2644C6.6835 33.3342 6.77854 33.3734 6.87761 33.3734C6.97668 33.3734 7.07172 33.3342 7.14199 33.2644L25.4082 15ZM33.2645 6.61312L29.387 2.73562C29.3522 2.70076 29.3108 2.6731 29.2653 2.65423C29.2198 2.63535 29.171 2.62564 29.1217 2.62564C29.0724 2.62564 29.0236 2.63535 28.9781 2.65423C28.9325 2.6731 28.8912 2.70076 28.8564 2.73562L22.5901 9L27.0001 13.41L33.2645 7.14375C33.2994 7.10892 33.327 7.06756 33.3459 7.02204C33.3648 6.97651 33.3745 6.92772 33.3745 6.87844C33.3745 6.82915 33.3648 6.78036 33.3459 6.73483C33.327 6.68931 33.2994 6.64795 33.2645 6.61312Z"
            fill="white"/>
      </svg>
      <div class="star-wrapper">
        <svg :class="`svg__${value}`" v-for="(value) in 4" :key="value" viewBox="0 0 12 12" fill="none"
             xmlns="http://www.w3.org/2000/svg">
          <path
              d="M1.12695 6.75H4.50195V10.125C4.50195 10.4234 4.62048 10.7095 4.83146 10.9205C5.04244 11.1315 5.32858 11.25 5.62695 11.25C5.92532 11.25 6.21147 11.1315 6.42245 10.9205C6.63343 10.7095 6.75195 10.4234 6.75195 10.125V6.75H10.127C10.4253 6.75 10.7115 6.63147 10.9224 6.42049C11.1334 6.20952 11.252 5.92337 11.252 5.625C11.252 5.32663 11.1334 5.04048 10.9224 4.8295C10.7115 4.61853 10.4253 4.5 10.127 4.5H6.75195V1.125C6.75195 0.826631 6.63343 0.540483 6.42245 0.329505C6.21147 0.118526 5.92532 0 5.62695 0C5.32858 0 5.04244 0.118526 4.83146 0.329505C4.62048 0.540483 4.50195 0.826631 4.50195 1.125V4.5H1.12695C0.828585 4.5 0.542436 4.61853 0.331458 4.8295C0.120479 5.04048 0.00195313 5.32663 0.00195312 5.625C0.00195313 5.92337 0.120479 6.20952 0.331458 6.42049C0.542436 6.63147 0.828585 6.75 1.12695 6.75Z"
              fill="white"/>
        </svg>

      </div>
    </div>
  </router-link>
</template>

<script>
import {mapGetters} from "vuex";

export default {
  name: "float-btn",
  computed: {
    ...mapGetters(['getSmallMenu', 'getIsWhiteBg'])
  }
}
</script>

<style scoped lang="scss">
@import "@/assets/style/styles";

.float-btn {
  position: fixed;
  bottom: 60px;
  right: 60px;
  z-index: 3;

  display: flex;
  justify-content: center;
  align-items: center;
  text-decoration: none;

  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.3);

  //backdrop-filter: blur(20px);

  border-radius: 60px;
  height: 86px;
  transition: width .2s ease;

  &.white {
    background: rgba(255, 255, 255, 0.1);
    border: 1px solid #8E2959;

    border-radius: 60px;

    .big-wrapper {
      p {
        color: #8E2959;
      }

    }

    .static {
      path {
        fill: #8E2959;
      }
    }

    .small-wrapper {
      svg {
        path {
          fill: #8E2959;
        }
      }
    }

    .star-wrapper {
      svg {
        path {
          fill: #67267A;
        }
      }
    }
  }

  @media screen and (max-width: 1160px) {
    bottom: 20px;
    right: 20px;
    height: 64px;
  }

  &.smallMenu {
    width: 86px;

    @media screen and (max-width: 1160px) {
      width: 64px;
    }

    &:before {
      content: '';
      width: calc(100%);
      height: calc(100%);
      position: absolute;
      left: 0;
      top: 0;
      right: 0;

      background: radial-gradient(50% 50% at 50% 50%, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.2) 100%);
      //border: 2px solid rgba(255, 255, 255, 0) !important;
      border-radius: 60px;

      opacity: 0;
      transition: background-color .2s ease;
    }
  }

  &.bigMenu {
    width: 337px;

    @media screen and (max-width: 1160px) {
      width: 320px;
    }

    @media screen and (max-width: 425px) {
      max-width: calc(100% - 40px);
      width: 100%;
    }

    p {
      opacity: 1 !important;
      transition-property: opacity;
      transition-timing-function: ease-in-out;
      transition-duration: .2s;
      transition-delay: 0.1s;
    }

    .static {
      opacity: 1 !important;

      transition-property: opacity;
      transition-timing-function: ease-in-out;
      transition-duration: .2s;
      transition-delay: 0.1s;
    }

    &:before {
      content: '';
      width: calc(100% - 2px);
      height: calc(100% - 2px);
      position: absolute;
      left: 0;
      top: 0;
      right: 0;

      background: radial-gradient(50% 50% at 50% 50%, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.2) 100%);
      border: 2px solid rgba(255, 255, 255, 0) !important;
      border-radius: 60px;


      opacity: 0;
      transition: opacity .2s ease;
    }
  }

  .big-wrapper {
    pointer-events: none;

    p {
      font-family: $light;
      font-size: 24px;
      line-height: 29px;
      color: white;

      letter-spacing: 0.02em;
      text-transform: uppercase;

      opacity: 0;

      @media screen and (max-width: 1160px) {
        font-size: 20px;
        line-height: 24px;
      }
    }

    .static {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);

      opacity: 0;
      width: 218px;
      height: auto;
      display: block;

      @media screen and (max-width: 1160px) {
        width: 190px;
      }
    }

    .star-wrapper {
      position: absolute;
      width: 218px;

      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);

      @media screen and (max-width: 1160px) {
        display: none;
      }

      svg {
        height: auto;
        width: 9px;
        position: absolute;
        opacity: 0;
        transition: top .2s ease;

        &.svg {

          &__1 {
            left: -12px;
            top: 0;
          }

          &__2 {
            width: 12px;
            left: -35px;
            top: -10px;
          }

          &__3 {
            left: 12px;
            top: -20px;
          }

          &__4 {
            width: 12px;
            left: 20px;
            top: -30px;
          }

          &__5 {
            width: 12px;
            right: 25px;
            top: -30px;
          }

          &__6 {
            right: 12px;
            top: -20px;
          }

          &__7 {
            width: 12px;
            right: 42px;
            top: -23px;
          }

          &__8 {
            right: -8px;
            top: -11px;
          }
        }

      }
    }
  }

  .small-wrapper {
    pointer-events: none;

    position: absolute;

    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);

    .star-wrapper {
      position: absolute;
      width: 86px;

      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);

      @media screen and (max-width: 1160px) {
        display: none;
      }

      svg {
        height: auto;
        width: 9px;
        position: absolute;
        opacity: 0;
        transition: top .2s ease;

        &.svg {

          &__1 {
            left: 8px;
            top: 0;
          }

          &__2 {
            width: 12px;
            left: 16px;
            top: -24px;
          }

          &__3 {
            right: 12px;
            top: -20px;
          }

          &__4 {
            width: 12px;
            right: 20px;
            top: -30px;
          }
        }
      }
    }

  }

  svg {
    display: block;
    width: 41px;
    height: auto;
    @media screen and (max-width: 1160px) {
      width: 32px;
    }
  }
}
</style>